import React from 'react';

export default function IcFeito() {
  return (
    <svg width="14px" height="13px" viewBox="0 0 14 13" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <g id="Organizacional/Calendário" stroke="none" fill="none" fillRule="evenodd">
            <g id="ORG-/-CALENDARIO-/-NOVA-TAREFA-FILL" transform="translate(-899.000000, -252.000000)" fill="#000">
                <g id="CARD-NOVO" transform="translate(377.000000, 160.000000)">
                    <g id="Side-Menu" transform="translate(516.000000, 39.000000)">
                        <g id="ACOES">
                            <g id="Feito" transform="translate(0.000000, 44.000000)">
                                <g id="ICON-/-FEITO" transform="translate(7.000000, 9.428571)">
                                    <path d="M6,0 C9.30834783,0 12,2.69165217 12,6 C12,9.30834783 9.30834783,12 6,12 C2.69165217,12 0,9.30834783 0,6 C0,2.69165217 2.69165217,0 6,0 Z M6,0.52173913 C2.97913043,0.52173913 0.52173913,2.97913043 0.52173913,6 C0.52173913,9.02086957 2.97913043,11.4782609 6,11.4782609 C9.02086957,11.4782609 11.4782609,9.02086957 11.4782609,6 C11.4782609,2.97913043 9.02086957,0.52173913 6,0.52173913 Z M9.57547826,3.98921739 C9.67773913,4.09147826 9.67773913,4.25634783 9.57547826,4.3586087 L5.40156522,8.53252174 C5.35095652,8.58313043 5.28417391,8.60869565 5.2173913,8.60869565 C5.1506087,8.60869565 5.08382609,8.58313043 5.03269565,8.53252174 L2.424,5.92382609 C2.32226087,5.82156522 2.32226087,5.65669565 2.424,5.55443478 C2.52626087,5.45269565 2.69113043,5.45269565 2.79286957,5.55443478 L5.2173913,7.97895652 L9.2066087,3.98921739 C9.30886957,3.88747826 9.47373913,3.88747826 9.57547826,3.98921739 Z" id="Combined-Shape"></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
  );
}
